import type { TextProps } from ".";
import type { TypographyProps } from "../Typography/Typography.types";

export const getTextProp = ({
  bold,
  size,
}: Required<Pick<TextProps, "size" | "bold">>): TypographyProps<"p">[] => {
  switch (size) {
    case "large":
      return [{ variant: bold ? "body-large-bold" : "body-large" }, { variant: "body-medium" }];

    case "xlarge":
      return [{ variant: "heading-xlarge-bold" }, { variant: "body-medium" }];

    case "xsmall":
      return [{ variant: bold ? "body-small-bold" : "body-small" }, { variant: "body-small" }];

    default:
      return [{ variant: bold ? "body-medium-bold" : "body-medium" }, { variant: "body-small" }];
  }
};
